<template>
  <div>
    <input id="handler" type="checkbox" v-model="state" @change="handler"/>
    <label class="container" for="handler"><div class="icon"/></label>
  </div>
</template>

<script>

export default {
  props: {
    value: Boolean
  },
  model: {
    prop: "value",
    event: "change"
  },
  data:() => ({
    state: false,
  }),
  watch: {
    value(updatedValue) {
      this.state = updatedValue;
    }
  },
  methods: {
    handler() {
      this.$emit("change", this.state);
    },
    changeLocale(lang) {
      this.$i18n.locale = lang;
    },
  }
}
</script>

<style lang="scss" scoped>
#handler {
  display: none;
}

// icon icon
.container {
  cursor: pointer;
  position: fixed;
  right: 29px;
  top: 14px;
  width: 26px;
  height: 30px;
  padding: 6px;
  .icon {
    position: relative;
    height: 2px;
    width: 26px;
    top: 50%;
    transition: background .2s ease-out;

    &:before, &:after {
      position: absolute;
      content: '';
      height: 100%;
      width: 100%;
      transition: all .2s ease-out;
    }
    &:before {
      top: -7px;
    }
    &:after {
      top: 7px;
    }
  }
  .icon, .icon:before, .icon:after {
    background-color: $primary2;
  }

  // when menu opened
  #handler:checked ~ & {
    .icon {
      background: transparent;
    }
    .icon:before {
      top: 0px;
      transform: rotate(-45deg);
    }
    .icon:after {
      top: 0px;
      transform: rotate(45deg);
    }
  }
}
</style>